import './one-column.scss';

/**
 * version    1.0
 * class      <type> (one column)
 * classdesc  Component that manage the one column layout
 */
export class OneColumn {}
